export function ourMissionSlider() {
    const $slider = $(".our-mission-slider");
    $slider.each(function () {
        let $this = $(this);
        $this.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            infinite: true,
            arrows: false,
            fade: true,
            dots: true,
            autoplay: true,
            mobileFirst: true,
            autoplaySpeed: 4000,
            pauseOnFocus: false,
            pauseOnHover: false,
        });
        $this.parent(".our-mission").on("click", function () {
            $this.slick("slickNext");
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ourMissionSlider.js